var Color = [
	[
		"rgba(90, 138, 204, 0.6)", "rgba(95, 145, 215, 0.6)", "rgba(119, 161, 221, 0.6)", "rgba(143, 178, 227, 0.6)", "rgba(167, 194, 233, 0.6)",
		"rgba(90, 166, 204, 0.6)", "rgba(95, 175, 215, 0.6)", "rgba(119, 187, 221, 0.6)", "rgba(143, 199, 227, 0.6)", "rgba(167, 211, 233, 0.6)",
		"rgba(90, 185, 204, 0.6)", "rgba(94, 195, 215, 0.6)", "rgba(119, 204, 221, 0.6)", "rgba(143, 213, 227, 0.6)", "rgba(166, 222, 233, 0.6)",
		"rgba(128, 90, 204, 0.6)", "rgba(135, 95, 215, 0.6)", "rgba(153, 119, 221, 0.6)", "rgba(171, 143, 227, 0.6)", "rgba(189, 167, 233, 0.6)",
		"rgba(100, 90, 204, 0.6)", "rgba(104, 95, 215, 0.6)", "rgba(127, 119, 221, 0.6)", "rgba(150, 143, 227, 0.6)", "rgba(171, 167, 233, 0.6)",
		"rgba(90, 109, 203, 0.6)", "rgba(95, 115, 214, 0.6)", "rgba(119, 136, 221, 0.6)", "rgba(143, 157, 227, 0.6)", "rgba(167, 178, 233, 0.6)",
		"rgba(102, 193, 193, 0.6)", "rgba(107, 203, 203, 0.6)", "rgba(129, 211, 211, 0.6)", "rgba(151, 219, 219, 0.6)", "rgba(173, 226, 226, 0.6)",
		"rgba(102, 193, 178, 0.6)", "rgba(107, 203, 187, 0.6)", "rgba(129, 210, 197, 0.6)", "rgba(151, 219, 207, 0.6)", "rgba(174, 226, 218, 0.6)",
		"rgba(102, 193, 155, 0.6)", "rgba(106, 203, 163, 0.6)", "rgba(129, 211, 177, 0.6)", "rgba(151, 219, 191, 0.6)", "rgba(174, 226, 204, 0.6)",
		"rgba(102, 193, 140, 0.6)", "rgba(107, 203, 147, 0.6)", "rgba(129, 211, 163, 0.6)", "rgba(151, 219, 179, 0.6)", "rgba(174, 226, 196, 0.6)",
	],
	[
		"rgba(242, 100, 52, 0.6)", "rgba(255, 105, 55, 0.6)", "rgba(255, 127, 85, 0.6)", "rgba(255, 150, 115, 0.6)", "rgba(255, 172, 145, 0.6)",
		"rgba(242, 131, 51, 0.6)", "rgba(255, 138, 56, 0.6)", "rgba(255, 156, 85, 0.6)", "rgba(255, 173, 115, 0.6)", "rgba(255, 191, 145, 0.6)",
		"rgba(242, 147, 52, 0.6)", "rgba(255, 155, 55, 0.6)", "rgba(255, 170, 85, 0.6)", "rgba(255, 185, 115, 0.6)", "rgba(255, 200, 145, 0.6)",
		"rgba(242, 163, 52, 0.6)", "rgba(255, 172, 56, 0.6)", "rgba(255, 184, 85, 0.6)", "rgba(255, 197, 116, 0.6)", "rgba(255, 209, 145, 0.6)",
		"rgba(242, 179, 52, 0.6)", "rgba(255, 188, 55, 0.6)", "rgba(255, 198, 86, 0.6)", "rgba(255, 208, 115, 0.6)", "rgba(255, 218, 145, 0.6)",
		"rgba(238, 193, 56, 0.6)", "rgba(250, 202, 60, 0.6)", "rgba(251, 211, 89, 0.6)", "rgba(252, 219, 118, 0.6)", "rgba(252, 226, 148, 0.6)",
		"rgba(233, 203, 58, 0.6)", "rgba(245, 214, 62, 0.6)", "rgba(246, 220, 90, 0.6)", "rgba(248, 226, 119, 0.6)", "rgba(249, 232, 148, 0.6)",
		"rgba(228, 67, 121, 0.6)", "rgba(240, 69, 127, 0.6)", "rgba(242, 98, 146, 0.6)", "rgba(244, 125, 165, 0.6)", "rgba(247, 153, 185, 0.6)",
		"rgba(233, 62, 76, 0.6)", "rgba(245, 65, 80, 0.6)", "rgba(246, 93, 106, 0.6)", "rgba(248, 122, 132, 0.6)", "rgba(249, 150, 159, 0.6)",
		"rgba(238, 71, 57, 0.6)", "rgba(250, 76, 60, 0.6)", "rgba(251, 103, 89, 0.6)", "rgba(252, 130, 118, 0.6)", "rgba(252, 157, 148, 0.6)",
	],
	[
		"rgba(90, 138, 204, 0.6)", "rgba(95, 145, 215, 0.6)", "rgba(119, 161, 221, 0.6)", "rgba(143, 178, 227, 0.6)", "rgba(167, 194, 233, 0.6)",
		"rgba(90, 166, 204, 0.6)", "rgba(95, 175, 215, 0.6)", "rgba(119, 187, 221, 0.6)", "rgba(143, 199, 227, 0.6)", "rgba(167, 211, 233, 0.6)",
		"rgba(90, 185, 204, 0.6)", "rgba(94, 195, 215, 0.6)", "rgba(119, 204, 221, 0.6)", "rgba(143, 213, 227, 0.6)", "rgba(166, 222, 233, 0.6)",
		"rgba(128, 90, 204, 0.6)", "rgba(135, 95, 215, 0.6)", "rgba(153, 119, 221, 0.6)", "rgba(171, 143, 227, 0.6)", "rgba(189, 167, 233, 0.6)",
		"rgba(100, 90, 204, 0.6)", "rgba(104, 95, 215, 0.6)", "rgba(127, 119, 221, 0.6)", "rgba(150, 143, 227, 0.6)", "rgba(171, 167, 233, 0.6)",
		"rgba(90, 109, 203, 0.6)", "rgba(95, 115, 214, 0.6)", "rgba(119, 136, 221, 0.6)", "rgba(143, 157, 227, 0.6)", "rgba(167, 178, 233, 0.6)",
		"rgba(102, 193, 193, 0.6)", "rgba(107, 203, 203, 0.6)", "rgba(129, 211, 211, 0.6)", "rgba(151, 219, 219, 0.6)", "rgba(173, 226, 226, 0.6)",
		"rgba(102, 193, 178, 0.6)", "rgba(107, 203, 187, 0.6)", "rgba(129, 210, 197, 0.6)", "rgba(151, 219, 207, 0.6)", "rgba(174, 226, 218, 0.6)",
		"rgba(102, 193, 155, 0.6)", "rgba(106, 203, 163, 0.6)", "rgba(129, 211, 177, 0.6)", "rgba(151, 219, 191, 0.6)", "rgba(174, 226, 204, 0.6)",
		"rgba(102, 193, 140, 0.6)", "rgba(107, 203, 147, 0.6)", "rgba(129, 211, 163, 0.6)", "rgba(151, 219, 179, 0.6)", "rgba(174, 226, 196, 0.6)",
		"rgba(242, 100, 52, 0.6)", "rgba(255, 105, 55, 0.6)", "rgba(255, 127, 85, 0.6)", "rgba(255, 150, 115, 0.6)", "rgba(255, 172, 145, 0.6)",
		"rgba(242, 131, 51, 0.6)", "rgba(255, 138, 56, 0.6)", "rgba(255, 156, 85, 0.6)", "rgba(255, 173, 115, 0.6)", "rgba(255, 191, 145, 0.6)",
		"rgba(242, 147, 52, 0.6)", "rgba(255, 155, 55, 0.6)", "rgba(255, 170, 85, 0.6)", "rgba(255, 185, 115, 0.6)", "rgba(255, 200, 145, 0.6)",
		"rgba(242, 163, 52, 0.6)", "rgba(255, 172, 56, 0.6)", "rgba(255, 184, 85, 0.6)", "rgba(255, 197, 116, 0.6)", "rgba(255, 209, 145, 0.6)",
		"rgba(242, 179, 52, 0.6)", "rgba(255, 188, 55, 0.6)", "rgba(255, 198, 86, 0.6)", "rgba(255, 208, 115, 0.6)", "rgba(255, 218, 145, 0.6)",
		"rgba(238, 193, 56, 0.6)", "rgba(250, 202, 60, 0.6)", "rgba(251, 211, 89, 0.6)", "rgba(252, 219, 118, 0.6)", "rgba(252, 226, 148, 0.6)",
		"rgba(233, 203, 58, 0.6)", "rgba(245, 214, 62, 0.6)", "rgba(246, 220, 90, 0.6)", "rgba(248, 226, 119, 0.6)", "rgba(249, 232, 148, 0.6)",
		"rgba(228, 67, 121, 0.6)", "rgba(240, 69, 127, 0.6)", "rgba(242, 98, 146, 0.6)", "rgba(244, 125, 165, 0.6)", "rgba(247, 153, 185, 0.6)",
		"rgba(233, 62, 76, 0.6)", "rgba(245, 65, 80, 0.6)", "rgba(246, 93, 106, 0.6)", "rgba(248, 122, 132, 0.6)", "rgba(249, 150, 159, 0.6)",
		"rgba(238, 71, 57, 0.6)", "rgba(250, 76, 60, 0.6)", "rgba(251, 103, 89, 0.6)", "rgba(252, 130, 118, 0.6)", "rgba(252, 157, 148, 0.6)",
	]
];


function GetColors(set, i, opaque) {
	if (i == null) {
		var newSet = [];
		for (var x = 0; x < Color[set].length; x++) {
			newSet.push(GetColors(set, x, opaque))
		}
		return newSet;
	}

	var skip = 20;
	var groups = Color[set].length / skip;
	var group = Math.floor(i / groups)
	var t = i % groups * skip + group;

	var color = Color[set][t];
	if (opaque !== undefined && color !== undefined) {
		var split = color.split(",");
		split[split.length - 1] = " " + opaque + ")";
		color = split.join(",");
	}

	return color;

}

class Colors {
	GetColors(set, i, opaque) {
		return GetColors(set, i, opaque);
	}
}

export default new Colors();
